import { Draft } from '@reduxjs/toolkit';

import { ISettingsData } from '../../index';

function editSuccess(draft: Draft<ISettingsData>) {
  draft.edit.config.isLoading = false;
}

export default editSuccess;
